import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import {
	createEmptyOwnedStateResource,
	createEmptyStateResource,
	OwnedStateResource,
	StateResource,
} from '@schir-int-client/ngrx-helpers';
import { isNil } from 'lodash-es';
import { KontaktInVerfahrenListResource, KontaktListResource, KontaktResource } from './adressverwaltung.model';
import { adressverwaltungFeatureState, AdressverwaltungRootState } from './adressverwaltung.state';

export const selectFeature = createFeatureSelector<AdressverwaltungRootState>(adressverwaltungFeatureState);

export const kontakteBySearchSelector: MemoizedSelector<
	object,
	OwnedStateResource<KontaktListResource>
> = createSelector(selectFeature, (state: AdressverwaltungRootState) => {
	const fromState = state?.adressverwaltungRoot.kontakteBySearch;
	if (isNil(fromState)) {
		return createEmptyOwnedStateResource<KontaktListResource>();
	}
	if (fromState.loaded) {
		return { ...fromState, resource: fromState.resource };
	}
	return { ...fromState, resource: null };
});

export const kontakteInVerfahrenSelector: MemoizedSelector<
	object,
	StateResource<KontaktInVerfahrenListResource>
> = createSelector(selectFeature, (state: AdressverwaltungRootState) => {
	const fromState = state?.adressverwaltungRoot.kontakteInVerfahren;
	if (isNil(fromState)) {
		return createEmptyStateResource<KontaktInVerfahrenListResource>();
	}
	if (fromState.loaded) {
		return { ...fromState, resource: fromState.resource };
	}
	return { ...fromState, resource: null };
});

export const selectedKontaktSelector: MemoizedSelector<object, KontaktResource> = createSelector(
	selectFeature,
	(state: AdressverwaltungRootState) => {
		if (!isNil(state.adressverwaltungRoot.selectedKontakt)) {
			return state.adressverwaltungRoot.selectedKontakt;
		}
		return null;
	}
);

export const editModeSelector: MemoizedSelector<object, boolean> = createSelector(
	selectFeature,
	(state: AdressverwaltungRootState) => state?.adressverwaltungRoot.editMode
);
